// extracted by mini-css-extract-plugin
export default {"ratings":"awNzlc","ratingsDisplay":"sHCAnr","ratingsInfo":"HOuULa"};